import React from 'react'

import ClockIcon from 'Images/SVG/Clock.svg'
import DollarIcon from 'Images/SVG/Dollar.svg'
import {
  ListingDetailsContainer,
  ListingDetailsYearsContainer,
  ListingDetailsIcon,
  ListingDetailsExpSpan,
  ListingDetailsPayContainer,
  ListingDetailsPayFacetContainer,
  ListingDetailsPaySpan,
} from './Styled'

const ListingDetails = ({ payRate, yearsExp }) => {
  const renderPayRate =
    payRate && typeof payRate === 'object' && Object.keys(payRate).length > 0 && payRate.value !== 0

  function renderCorrectPayFacet(payRate) {
    if (renderPayRate) {
      return payRate.value + '/' + payRate.unit
    } else {
      return 'Pay negotiable'
    }
  }

  return (
    <>
      <ListingDetailsContainer>
        {yearsExp && yearsExp !== 0 ? (
          <ListingDetailsYearsContainer>
            <ListingDetailsIcon src={ClockIcon} />
            <ListingDetailsExpSpan>{yearsExp} yrs experience</ListingDetailsExpSpan>
          </ListingDetailsYearsContainer>
        ) : null}
      </ListingDetailsContainer>
      <ListingDetailsPayContainer>
        <ListingDetailsPayFacetContainer display={{ _: 'inline-flex', tablet: 'inline-block' }}>
          <ListingDetailsIcon src={DollarIcon} verticalAlign='middle' />
          <ListingDetailsPaySpan>{renderCorrectPayFacet(payRate)}</ListingDetailsPaySpan>
        </ListingDetailsPayFacetContainer>
      </ListingDetailsPayContainer>
    </>
  )
}

export default ListingDetails
